import { useRecordContext } from 'react-admin';

import { GetB2bCampaignOneResponse } from '@Common/types/bo/b2b/campaigns';

import { getMatchingContributionRelatedCashSourceDisplayChoices } from '@sh4res/bo-common/components/B2bCampaigns/helpers/matchingContributionRelatedCashSource';
import { SelectChipField } from '@sh4res/bo-common/fields';

/**
 * Cash source a matching contribution campaign runs on. Voluntary deposits read as employee or
 * company voluntary deposits, depending on whether the campaign abounds another campaign.
 */
export const MatchingContributionRelatedCashSourceField = ({
  source = 'matching_contribution_related_cash_source',
  'data-testid': dataTestId,
}: {
  source?: string;
  'data-testid'?: string;
}) => {
  const record = useRecordContext<GetB2bCampaignOneResponse>();

  return (
    <SelectChipField
      source={source}
      choices={getMatchingContributionRelatedCashSourceDisplayChoices(record)}
      data-testid={dataTestId}
    />
  );
};
